import { Box, IconButton, Modal, Typography } from '@mui/material';
import React, { useState } from 'react';
import './SupportRejectModal.css';
import closeIcon from '../../../../../assets/Admin/RequestImages/close-icon.svg';
import rejectIcon from '../../../../../assets/Admin/RequestImages/reject-icon.svg';

const baseStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const SupportRejectModal = ({ setRejectOpen, onReject }) => {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setRejectOpen(false);
  };

  const handleReject = async () => {
    await onReject(reason);
    handleClose();
  };

  return (
    <Modal
      open={true}
      aria-labelledby="support-reject-modal-title"
      aria-describedby="support-reject-modal-description"
    >
      <Box
        sx={{
          ...baseStyle,
          width: '30%',
          maxHeight: '98vh',
          fontFamily: 'Poppins',
          borderRadius: '12px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box className="flex items-center justify-between px-6 py-4 border-b border-[#D5DEE3]">
          <Typography className="support-reject-title">Reject Support Request</Typography>
          <IconButton onClick={handleClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="flex flex-col items-center justify-center text-center gap-4 px-[11%] py-4 border-b border-[#D5DEE3]">
          <img src={rejectIcon} alt="reject" />
          <Typography className="support-reject-text">
            Are you sure you want to reject this support request?
          </Typography>
          <Box className="support-reason-container">
            <Typography className="support-reason-label">Reason</Typography>
            <textarea
              className="support-reason-textarea"
              placeholder="Write the reason for rejection..."
              value={reason}
              onChange={e => setReason(e.target.value)}
              rows={4}
            />
          </Box>
        </Box>
        <Box className="flex items-center justify-center gap-4 px-6 py-4">
          <button className="support-reject-cancel-button" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="support-reject-confirm-button"
            onClick={handleReject}
            disabled={!reason.trim()}
          >
            Reject
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SupportRejectModal;
